module.exports = __webpack_public_path__ + "media/images/emblems/Grindel-blason-9fcf70b5b7fed2fccaf64dc31728596e.png";